enum ContactUsTypes {
  CALL = 'call',
  TEXT = 'text',
  EMAIL = 'email',
  NO_FOLLOW_UP = 'no',
}

export default ContactUsTypes;
